import { defineAction } from '../utils/define-action';
import { getAge } from '../utils/helpers';
import { addProductToCart, removeProductFromCart } from './cart';
//import API from '../utils/api';
//const api = new API();

export const PROGRAM_TYPES = {
  WEEKLY_CAMP: 'Weekly Camp',
  FIVE_WEEK_CAMP: '5 Week Camp',
  THREE_WEEK_CAMP: '3 Week Camp',
  DAILY_CAMP: 'Daily Camp',
  FIVE_DAY_CAMP: '5 Day Camp',
  THREE_DAY_CAMP: '3 Day Camp',
};

const SET_SPORT = defineAction('SET_SPORT');
const SET_BUSINESS_TYPE = defineAction('SET_BUSINESS_TYPE');
const SET_BOARDING = defineAction('SET_BOARDING');
const SET_REFUNDABLE = defineAction('SET_REFUNDABLE');
const SET_LOCKED = defineAction('SET_LOCKED');
const SET_ISPOSITION = defineAction('SET_ISPOSITION');
const SET_IS_SECONDARY_POSITION = defineAction('SET_IS_SECONDARY_POSITION');
const SET_FORCED_REFUNDABLE = defineAction('SET_FORCED_REFUNDABLE');
const SET_CAMPER_FIELD = defineAction('SET_CAMPER_FIELD');
const SET_PARENT_FIELD = defineAction('SET_PARENT_FIELD');
const SELECT_CAMP_OPTION = defineAction('SELECT_CAMP_OPTION');
const DESELECT_CAMP_OPTION = defineAction('DESELECT_CAMP_OPTION');
const SET_PROGRAM_TYPE = defineAction('SET_PROGRAM_TYPE');
const SET_PROGRAM_PERIOD = defineAction('SET_PROGRAM_PERIOD');
const SET_SKIP_CONCENTRATIONS = defineAction('SET_SKIP_CONCENTRATIONS');
const SET_CONCENTRATION_DATA_LENGTH = defineAction(
  'SET_CONCENTRATION_DATA_LENGTH'
);
const SELECT_CONCENTRATION_OPTION = defineAction('SELECT_CONCENTRATION_OPTION');
const DESELECT_CONCENTRATION_OPTION = defineAction(
  'DESELECT_CONCENTRATION_OPTION'
);
const SELECT_ROOM_UPGRADE_OPTION = defineAction('SELECT_ROOM_UPGRADE_OPTION');
const DESELECT_ROOM_UPGRADE_OPTION = defineAction(
  'DESELECT_ROOM_UPGRADE_OPTION'
);
const SELECT_EXCURSION_OPTION = defineAction('SELECT_EXCURSION_OPTION');
const DESELECT_EXCURSION_OPTION = defineAction('DESELECT_EXCURSION_OPTION');
const SELECT_GEAR_OPTION = defineAction('SELECT_GEAR_OPTION');
const DESELECT_GEAR_OPTION = defineAction('DESELECT_GEAR_OPTION');
const SELECT_ESSENTIAL_OPTION = defineAction('SELECT_ESSENTIAL_OPTION');
const DESELECT_ESSENTIAL_OPTION = defineAction('DESELECT_ESSENTIAL_OPTION');
const SELECT_UPSELL_OPTION = defineAction('SELECT_UPSELL_OPTION');
const DESELECT_UPSELL_OPTION = defineAction('DESELECT_UPSELL_OPTION');
const SELECT_TRANSPORT_OPTION = defineAction('SELECT_TRANSPORT_OPTION');
const DESELECT_TRANSPORT_OPTION = defineAction('DESELECT_TRANSPORT_OPTION');
const UPDATE_OPTION_PARTICIPANT_ID = defineAction(
  'UPDATE_OPTION_PARTICIPANT_ID'
);
const SET_TRANSPORT_CHOICE = defineAction('SET_TRANSPORT_CHOICE');
const RESET_SELECTED_OPTIONS = defineAction('RESET_SELECTED_OPTIONS');
const RESET_BUNDLE_OPTIONS = defineAction('RESET_BUNDLE_OPTIONS');
const RESET_CONCENTRATION_OPTIONS = defineAction('RESET_CONCENTRATION_OPTIONS');

export const initialState = {
  sport: null,
  businessType: null,
  boarding: null,
  programPeriod: null,
  programType: null,
  programLengthInWeeks: null,
  programLengthInDays: null,
  selectedCampOptions: {},
  skipConcentrations: false, // Whether we should display concentration step or not at all
  concentrationsDataLength: null, // Some weeks has no data, so we need this to know if concentration step is completed
  selectedConcentrationOptions: {},
  selectedRoomUpgradeOptions: {},
  selectedExcursionOptions: {},
  selectedGearOptions: {},
  selectedEssentialOptions: {},
  selectedUpsellOptions: {},
  selectedTransportOptions: {},
  transportChoice: null,
  refundable: null,
  forcedRefundable: null,
  locked: false,
  isposition: false,
  issecondaryposition: false,
  camper: {
    birthdate: null,
    age: null,
    gender: null,
    position: null,
    firstName: '',
    lastName: '',
    email: '', // optional
    phoneNumber: '', // optional
    secondaryPosition: '', // Can be optional
    secondaryPositionName: '', // Can be optional
    mainPosition: 'Default', // Can be optional
    shirtSize: '',
    shortSize: '',
  },
  parent: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    zipcode: '',
    country: '',
  },
};

export const setSport = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_SPORT,
      payload: value,
    });

    dispatch(resetSelectedOptions());
  };
};

export const setBusinessType = (value) => {
  console.log('setBusinessType', value);
  return (dispatch) => {
    dispatch({
      type: SET_BUSINESS_TYPE,
      payload: value,
    });
    dispatch(resetSelectedOptions());
  };
};

export const setBoarding = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_BOARDING,
      payload: value,
    });

    dispatch(resetSelectedOptions());
  };
};

export const setLocked = (value) => {
  return {
    type: SET_LOCKED,
    payload: value,
  };
};

export const setIsposition = (value) => {
  return {
    type: SET_ISPOSITION,
    payload: value,
  };
};
export const setIsSecondaryPosition = (value) => {
  return {
    type: SET_IS_SECONDARY_POSITION,
    payload: value,
  };
};

export const setRefundable = (value) => {
  return {
    type: SET_REFUNDABLE,
    payload: value,
  };
};

export const setForcedRefundable = (value) => {
  return {
    type: SET_FORCED_REFUNDABLE,
    payload: value,
  };
};

export const setCamperField = (key, value) => {
  return (dispatch, getState) => {
    const birthdateChanged =
      key === 'birthdate' && value !== getState().form.camper.birthdate;
    const genderChanged =
      key === 'gender' && value !== getState().form.camper.gender;

    if (genderChanged || birthdateChanged) {
      dispatch(resetSelectedOptions());
    }

    dispatch({
      type: SET_CAMPER_FIELD,
      payload: {
        key,
        value,
      },
    });

    if (key === 'birthdate') {

      // Check for adult and Get Gears products
      /*
      var isAdult = false;
      if(getAge(value)>18){
        isAdult = true;
      }
      console.log('isAdult:', isAdult, getAge(value));
      api.getImgorShopifyGearProductsByCollection(isAdult);
      */

      dispatch({
        type: SET_CAMPER_FIELD,
        payload: {
          key: 'age',
          value: value ? String(getAge(value)) : null,
        },
      });
    }
  };
};

export const setParentField = (key, value) => {
  return {
    type: SET_PARENT_FIELD,
    payload: {
      key,
      value,
    },
  };
};

export const selectCampOption = (key, value) => {
  return {
    type: SELECT_CAMP_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectCampOption = (key) => {
  return {
    type: DESELECT_CAMP_OPTION,
    payload: {
      key,
    },
  };
};

export const resetSelectedOptions = () => {
  return async (dispatch, getState) => {
    const selected = {
      ...getState().form.selectedCampOptions,
      ...getState().form.selectedConcentrationOptions,
      ...getState().form.selectedGearOptions,
      ...getState().form.selectedExcursionOptions,
      ...getState().form.selectedEssentialOptions,
      ...getState().form.selectedUpsellOptions,
      ...getState().form.selectedRoomUpgradeOptions,
    };

    if (Object.keys(selected).length === 0) {
      return;
    }

    dispatch({
      type: RESET_SELECTED_OPTIONS,
    });

    Object.keys(selected).map((key) =>
      dispatch(removeProductFromCart(selected[key].participantProductId))
    );
  };
};

export const resetBundleOptions = () => {
  return async (dispatch, getState) => {
    const selected = {
      ...getState().form.selectedGearOptions,
      ...getState().form.selectedExcursionOptions,
      ...getState().form.selectedEssentialOptions,
      ...getState().form.selectedUpsellOptions,
      ...getState().form.selectedTransportOptions,
      ...getState().form.selectedRoomUpgradeOptions,
    };

    if (Object.keys(selected).length === 0) {
      return;
    }

    dispatch({
      type: RESET_BUNDLE_OPTIONS,
    });

    return Promise.all(
      Object.keys(selected).map((key) =>
        dispatch(removeProductFromCart(selected[key].participantProductId))
      )
    );
  };
};

export const resetConcentrationOptions = () => {
  return async (dispatch, getState) => {
    const selected = getState().form.selectedConcentrationOptions;

    if (Object.keys(selected).length === 0) {
      return;
    }

    dispatch({
      type: RESET_CONCENTRATION_OPTIONS,
    });

    return Promise.all(
      Object.keys(selected).map((key) =>
        dispatch(removeProductFromCart(selected[key].participantProductId))
      )
    );
  };
};

export const setProgramType = (p) => {
  return {
    type: SET_PROGRAM_TYPE,
    payload: {
      programLengthInWeeks: p.weeksLength,
      programLengthInDays: p.daysLength,
      type: p.type,
    },
  };
};

export const setProgramPeriod = (value) => {
  return {
    type: SET_PROGRAM_PERIOD,
    payload: value,
  };
};

export const setSkipConcentrations = (value) => {
  return {
    type: SET_SKIP_CONCENTRATIONS,
    payload: {
      value,
    },
  };
};

export const setConcentrationDataLength = (value) => {
  return {
    type: SET_CONCENTRATION_DATA_LENGTH,
    payload: {
      value,
    },
  };
};

export const selectConcentrationOption = (key, value) => {
  return {
    type: SELECT_CONCENTRATION_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectConcentrationOption = (key) => {
  return {
    type: DESELECT_CONCENTRATION_OPTION,
    payload: {
      key,
    },
  };
};

export const selectRoomUpgradeOption = (key, value) => {
  return {
    type: SELECT_ROOM_UPGRADE_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectRoomUpgradeOption = (key) => {
  return {
    type: DESELECT_ROOM_UPGRADE_OPTION,
    payload: {
      key,
    },
  };
};

export const selectExcursionOption = (key, value) => {
  return {
    type: SELECT_EXCURSION_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectExcursionOption = (key) => {
  return {
    type: DESELECT_EXCURSION_OPTION,
    payload: {
      key,
    },
  };
};

export const selectGearOption = (key, value) => {
  return {
    type: SELECT_GEAR_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectGearOption = (key) => {
  return {
    type: DESELECT_GEAR_OPTION,
    payload: {
      key,
    },
  };
};

export const selectEssentialOption = (key, value) => {
  return {
    type: SELECT_ESSENTIAL_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectEssentialOption = (key) => {
  return {
    type: DESELECT_ESSENTIAL_OPTION,
    payload: {
      key,
    },
  };
};

export const selectUpsellOption = (key, value) => {
  return {
    type: SELECT_UPSELL_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectUpsellOption = (key) => {
  return {
    type: DESELECT_UPSELL_OPTION,
    payload: {
      key,
    },
  };
};

export const selectTransportOption = (key, value) => {
  console.log('selectTransportOption', key, value);
  return {
    type: SELECT_TRANSPORT_OPTION,
    payload: {
      key,
      value,
    },
  };
};

export const deselectTransportOption = (key) => {
  return {
    type: DESELECT_TRANSPORT_OPTION,
    payload: {
      key,
    },
  };
};

export const setTransportChoice = (choice) => {
  return {
    type: SET_TRANSPORT_CHOICE,
    payload: {
      choice,
    },
  };
};

const updateOptionParticipantProductId = (key, id, participantProductId) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_OPTION_PARTICIPANT_ID,
      payload: {
        key,
        id,
        participantProductId,
      },
    });
  };
};

export const addExistentProducts = () => {
  return (dispatch, getState) => {
    Promise.all(
      Object.values(getState().form.selectedCampOptions).map(async (camp) => {
        const res = await dispatch(
          addProductToCart({
            type: 'camp',
            product: camp.product,
          })
        );

        dispatch(
          updateOptionParticipantProductId(
            'selectedCampOptions',
            camp.product.id,
            res.participant_product_id
          )
        );
      })
    );

    Promise.all(
      Object.values(getState().form.selectedConcentrationOptions).map(
        async (concentration) => {
          console.log('addExistentProducts',concentration);
          const res = await dispatch(
            addProductToCart({
              type: 'concentration',
              product: concentration.product,
            })
          );

          dispatch(
            updateOptionParticipantProductId(
              'selectedConcentrationOptions',
              concentration.product.id,
              res.participant_product_id
            )
          );
        }
      )
    );

    // Following options may not have a product prop. Those are bundles
    // And are not added here, they are added in their respective component when mounted
    Promise.all(
      Object.values(getState().form.selectedRoomUpgradeOptions).map(
        async (room) => {
          if (!room.product) {
            return null;
          }

          const res = await dispatch(
            addProductToCart({
              type: 'gear',
              product: room.product,
            })
          );

          dispatch(
            updateOptionParticipantProductId(
              'selectedRoomUpgradeOptions',
              room.product.id,
              res.participant_product_id
            )
          );
        }
      )
    );

    Promise.all(
      Object.values(getState().form.selectedGearOptions).map(async (gear) => {
        if (!gear.product) {
          return null;
        }

        const res = await dispatch(
          addProductToCart({
            type: 'gear',
            product: gear.product,
          })
        );

        dispatch(
          updateOptionParticipantProductId(
            'selectedGearOptions',
            gear.product.id,
            res.participant_product_id
          )
        );
      })
    );

    Promise.all(
      Object.values(getState().form.selectedExcursionOptions).map(
        async (ex) => {
          if (!ex.product) {
            return null;
          }

          const res = await dispatch(
            addProductToCart({
              type: 'excursion',
              product: ex.product,
            })
          );

          dispatch(
            updateOptionParticipantProductId(
              'selectedExcursionOptions',
              ex.product.id,
              res.participant_product_id
            )
          );
        }
      )
    );

    Promise.all(
      Object.values(getState().form.selectedEssentialOptions).map(
        async (essential) => {
          if (!essential.product) {
            return null;
          }

          const res = await dispatch(
            addProductToCart({
              type: 'gear',
              product: essential.product,
              quantity: essential.quantity,
            })
          );

          dispatch(
            updateOptionParticipantProductId(
              'selectedEssentialOptions',
              essential.product.id,
              res.participant_product_id
            )
          );
        }
      )
    );

    Promise.all(
      Object.values(getState().form.selectedUpsellOptions).map(
        async (upsell) => {
          if (!upsell.product) {
            return null;
          }

          const res = await dispatch(
            addProductToCart({
              type: 'gear-upsell',
              product: upsell.product,
            })
          );

          dispatch(
            updateOptionParticipantProductId(
              'selectedUpsellOptions',
              upsell.product.id,
              res.participant_product_id
            )
          );
        }
      )
    );

    Promise.all(
      Object.values(getState().form.selectedTransportOptions).map(
        async (transport) => {
          const res = await dispatch(addProductToCart(transport.product));

          dispatch(
            updateOptionParticipantProductId(
              'selectedTransportOptions',
              transport.product.unique_id,
              res.participant_product_id
            )
          );
        }
      )
    );
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SPORT:
      return {
        ...state,
        sport: action.payload,
      };
    case SET_BOARDING:
      return {
        ...state,
        boarding: action.payload,
      };
    case SET_BUSINESS_TYPE:
      return {
        ...state,
        businessType: action.payload,
      };
    case SET_CAMPER_FIELD:
      return {
        ...state,
        camper: {
          ...state.camper,
          [action.payload.key]: action.payload.value,
        },
      };
    case SET_PARENT_FIELD:
      return {
        ...state,
        parent: {
          ...state.parent,
          [action.payload.key]: action.payload.value,
        },
      };
    case SELECT_CAMP_OPTION:
      return {
        ...state,
        selectedCampOptions: {
          ...state.selectedCampOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_CAMP_OPTION:
      const optionsAfterDeselect = Object.assign({}, state.selectedCampOptions);
      delete optionsAfterDeselect[action.payload.key];

      return {
        ...state,
        selectedCampOptions: optionsAfterDeselect,
      };
    case SET_PROGRAM_TYPE:
      return {
        ...state,
        programType: action.payload.type,
        programLengthInWeeks: action.payload.programLengthInWeeks,
        programLengthInDays: action.payload.programLengthInDays,
      };
    case SET_PROGRAM_PERIOD:
      return {
        ...state,
        programPeriod: action.payload,
      };
    case SET_SKIP_CONCENTRATIONS:
      return {
        ...state,
        skipConcentrations: action.payload.value,
      };
    case SET_CONCENTRATION_DATA_LENGTH:
      return {
        ...state,
        concentrationsDataLength: action.payload.value,
      };
    case SELECT_CONCENTRATION_OPTION:
      return {
        ...state,
        selectedConcentrationOptions: {
          ...state.selectedConcentrationOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_CONCENTRATION_OPTION:
      const selectedConcentrationOptions = Object.assign(
        {},
        state.selectedConcentrationOptions
      );
      delete selectedConcentrationOptions[action.payload.key];

      return {
        ...state,
        selectedConcentrationOptions,
      };
    case SELECT_EXCURSION_OPTION:
      return {
        ...state,
        selectedExcursionOptions: {
          ...state.selectedExcursionOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_EXCURSION_OPTION:
      const selectedExcursionOptions = Object.assign(
        {},
        state.selectedExcursionOptions
      );
      delete selectedExcursionOptions[action.payload.key];

      return {
        ...state,
        selectedExcursionOptions,
      };
    case SELECT_ROOM_UPGRADE_OPTION:
      return {
        ...state,
        selectedRoomUpgradeOptions: {
          ...state.selectedRoomUpgradeOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_ROOM_UPGRADE_OPTION:
      const selectedRoomUpgradeOptions = Object.assign(
        {},
        state.selectedRoomUpgradeOptions
      );
      delete selectedRoomUpgradeOptions[action.payload.key];

      return {
        ...state,
        selectedRoomUpgradeOptions,
      };
    case SELECT_GEAR_OPTION:
      return {
        ...state,
        selectedGearOptions: {
          ...state.selectedGearOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_GEAR_OPTION:
      const selectedGearOptions = Object.assign({}, state.selectedGearOptions);
      delete selectedGearOptions[action.payload.key];

      return {
        ...state,
        selectedGearOptions,
      };
    case SELECT_ESSENTIAL_OPTION:
      return {
        ...state,
        selectedEssentialOptions: {
          ...state.selectedEssentialOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_ESSENTIAL_OPTION:
      const selectedEssentialOptions = Object.assign(
        {},
        state.selectedEssentialOptions
      );
      delete selectedEssentialOptions[action.payload.key];

      return {
        ...state,
        selectedEssentialOptions,
      };
    case SELECT_UPSELL_OPTION:
      return {
        ...state,
        selectedUpsellOptions: {
          ...state.selectedUpsellOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_UPSELL_OPTION:
      const selectedUpsellOptions = Object.assign(
        {},
        state.selectedUpsellOptions
      );
      delete selectedUpsellOptions[action.payload.key];

      return {
        ...state,
        selectedUpsellOptions,
      };
    case SELECT_TRANSPORT_OPTION:
      return {
        ...state,
        selectedTransportOptions: {
          ...state.selectedTransportOptions,
          [action.payload.key]: action.payload.value,
        },
      };
    case DESELECT_TRANSPORT_OPTION:
      const selectedTransportOptions = Object.assign(
        {},
        state.selectedTransportOptions
      );
      delete selectedTransportOptions[action.payload.key];

      return {
        ...state,
        selectedTransportOptions,
      };
    case SET_TRANSPORT_CHOICE:
      return {
        ...state,
        transportChoice: action.payload.choice,
      };
    // Bit complex, but here we update an option particpand id
    // while keeping all the other props
    case UPDATE_OPTION_PARTICIPANT_ID:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          [action.payload.id]: {
            ...state[action.payload.key][action.payload.id],
            participantProductId: action.payload.participantProductId,
          },
        },
      };
    case RESET_SELECTED_OPTIONS:
      return {
        ...state,
        programType: null,
        programLengthInWeeks: null,
        programLengthInDays: null,
        skipConcentrations: false,
        selectedCampOptions: {},
        selectedRoomUpgradeOptions: {},
        selectedConcentrationOptions: {},
        selectedExcursionOptions: {},
        selectedGearOptions: {},
        selectedEssentialOptions: {},
        selectedUpsellOptions: {},
        selectedTransportOptions: {},
        includedPackages: {
          excursions: false,
          gears: false,
          essentials: false,
        },
      };
    case RESET_BUNDLE_OPTIONS:
      return {
        ...state,
        selectedRoomUpgradeOptions: {},
        selectedExcursionOptions: {},
        selectedGearOptions: {},
        selectedUpsellOptions: {},
        selectedEssentialOptions: {},
        selectedTransportOptions: {},
      };
    case RESET_CONCENTRATION_OPTIONS:
      return {
        ...state,
        hasConcentrationWeeks: false,
        concentrationsDataLength: null,
        selectedConcentrationOptions: {},
      };
    case SET_REFUNDABLE:
      return {
        ...state,
        refundable: action.payload,
      };
    case SET_FORCED_REFUNDABLE:
      return {
        ...state,
        forcedRefundable: action.payload,
      };
    case SET_LOCKED:
      return {
        ...state,
        locked: action.payload,
      };
    case SET_ISPOSITION:
      return {
        ...state,
        isposition: action.payload,
      };
    case SET_IS_SECONDARY_POSITION:
      return {
        ...state,
        issecondaryposition: action.payload,
      };
    default:
      return state;
  }
};
